import { Flex, HelpIndicator, Label } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";

export const AIFieldLabel = ({ label, showIcon }: { label: string; showIcon: boolean }) => {
  return (
    <Flex flexDirection="row" alignItems="center" gap={2}>
      <Label>{label}</Label>
      {showIcon && (
        <HelpIndicator
          id="ai-field-label"
          placement="top"
          content="This field has been auto-filled based on data extracted from the uploaded document. Please review the details."
        >
          <Icon
            type="circle-bolt"
            color={Colors.Success600}
            variant="solid"
            size="small"
            data-testid="circle-bolt"
          />
        </HelpIndicator>
      )}
    </Flex>
  );
};
